import IPhoneNumber from "@/app/dto/IPhoneNumber";
import Property from "@/app/dto/Property";

export default class OtpRequest {
    constructor(public mobile?: IPhoneNumber, public data?: Property[]) {
    }
}
